import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpenIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative flex items-center px-5 md:px-10 lg:px-16 pt-8 md:pt-12 overflow-hidden min-h-screen lg:min-h-[700px]" data-id="element-88" data-mp="28uo9kg0s6p59">
      <div className="absolute inset-0" data-id="element-89" data-mp="2wm36tudpag9n">
        <img src="https://cdn.magicpatterns.com/uploads/uUpuPt3gbZ7V5QdrqJgFQx/heylloyd-image-1782595699976.png" alt="Familia feliz y diversa con niños" className="w-full h-full object-cover" data-id="element-90" data-mp="30k96kig4fvl2" />
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(135deg, rgba(20, 80, 20, 0.65) 0%, rgba(0, 60, 10, 0.50) 50%, rgba(0, 40, 0, 0.40) 100%)'
      }} data-id="element-91" data-mp="2rr5yyqs5qcyc" />
      </div>

      <div className="relative max-w-5xl mx-auto text-center w-full pt-12 pb-20" data-id="element-92" data-mp="2ff0it5ua99mc">
        <img src="https://cdn.magicpatterns.com/uploads/4XjcpcjWQEZca1XxaXZTTT/pancita_feliz.png" alt="Pancita Feliz Foundation" className="animate-fade-in-down mx-auto mb-6" style={{
        width: '320px',
        height: 'auto',
        objectFit: 'contain',
        mixBlendMode: 'luminosity',
        filter: 'brightness(0) invert(1)',
        opacity: 0.95
      }} data-id="element-93" data-mp="2be6u4a90nqse" />

        <div className="flex items-center justify-center" style={{
        gap: '12px',
        marginBottom: '20px'
      }} data-id="element-94" data-mp="2u3wm6ple9ygm">
          <span style={{
          display: 'inline-block',
          width: '40px',
          height: '2px',
          background: '#7DC920',
          opacity: 0.8,
          verticalAlign: 'middle'
        }} data-id="element-95" data-mp="334uv9maoww62" />
          <span className="text-xs md:text-sm font-bold tracking-widest uppercase" style={{
          color: '#7DC920',
          textShadow: '0 0 20px rgba(125, 201, 32, 0.6)'
        }} data-id="element-96" data-mp="38tb8rn0knylv">
            Descubre • Conecta • Evoluciona
          </span>
          <span style={{
          display: 'inline-block',
          width: '40px',
          height: '2px',
          background: '#7DC920',
          opacity: 0.8,
          verticalAlign: 'middle'
        }} data-id="element-97" data-mp="3mt47o5m95l4x" />
        </div>

        <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight drop-shadow-lg mx-auto max-w-4xl" data-id="element-98" data-mp="jt784vbouxb">
          Apoyamos a familias con niños neurodiversos a acceder a lo que
          necesitan
        </h1>

        <p className="text-sm md:text-base lg:text-lg text-white opacity-90 mb-10 max-w-3xl mx-auto drop-shadow" data-id="element-99" data-mp="edket7phu4qe">
          Eliminamos las barreras económicas que separan a las familias de la
          educación, orientación especializada y evaluaciones profesionales
        </p>

        <div className="flex flex-col sm:flex-row sm:flex-wrap gap-3 justify-center" data-id="element-100" data-mp="1yvbhzp4wfggp">
          <Link to="/donar" className="w-full sm:w-auto inline-block text-center bg-primary text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-primary/90 transition-colors shadow-lg hover:shadow-xl" data-id="element-101" data-mp="1yxfswr17tfqh">
            Donar Ahora
          </Link>
          <Link to="/solicitar-ayuda" className="w-full sm:w-auto inline-block text-center border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-dark transition-colors" data-id="element-102" data-mp="2mk4kk4g10mka">
            Solicitar Ayuda
          </Link>
          <Link to="/tienda" className="mp-hero-tienda-btn w-full sm:w-auto inline-flex items-center justify-center gap-2 text-center transition-colors" style={{
          background: 'transparent',
          color: 'white',
          border: '2px solid rgba(255,255,255,0.7)',
          padding: '14px 28px',
          borderRadius: '8px',
          fontSize: '16px',
          fontWeight: 600,
          textDecoration: 'none'
        }} data-id="element-103" data-mp="28t96mdqo7f9u">
            <BookOpenIcon size={18} data-id="element-104" data-mp="2h12i7ruq8kav" />
            Tienda
          </Link>
        </div>
      </div>
    </section>;
}